__turbopack_context__.v({
  "card": "ProductStrip-module-scss-module__fy5zxG__card",
  "headerRow": "ProductStrip-module-scss-module__fy5zxG__headerRow",
  "nav": "ProductStrip-module-scss-module__fy5zxG__nav",
  "navButton": "ProductStrip-module-scss-module__fy5zxG__navButton",
  "productStrip": "ProductStrip-module-scss-module__fy5zxG__productStrip",
  "slide": "ProductStrip-module-scss-module__fy5zxG__slide",
  "track": "ProductStrip-module-scss-module__fy5zxG__track",
  "trackWrapper": "ProductStrip-module-scss-module__fy5zxG__trackWrapper",
});
